import { MapPin, Phone, MessageCircle } from "lucide-react";

const ADDRESS_LINES = [
  "Sri Lakshmi Agencies",
  "1-1104, Indranagar",
  "Ramakuppam - 517401",
];
const MOBILE = "9989436469";

export default function ContactSection() {
  return (
    <div data-testid="contact-section" className="max-w-xl">
      <h2 className="mb-1 text-xl font-bold text-slate-800">Contact Us</h2>
      <p className="mb-5 text-sm text-slate-500">We're happy to help with your orders.</p>

      <div className="space-y-3">
        <div className="flex items-start gap-3 rounded-xl border border-blue-100 bg-white p-4 shadow-sm">
          <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-blue-50 text-blue-600">
            <MapPin className="h-5 w-5" />
          </span>
          <div>
            <p className="text-sm font-semibold text-slate-800">Address</p>
            {ADDRESS_LINES.map((l) => (
              <p key={l} className="text-sm text-slate-600">{l}</p>
            ))}
          </div>
        </div>

        <a
          data-testid="contact-call-link"
          href={`tel:+91${MOBILE}`}
          className="flex items-center gap-3 rounded-xl border border-blue-100 bg-white p-4 shadow-sm transition hover:border-blue-300"
        >
          <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-blue-50 text-blue-600">
            <Phone className="h-5 w-5" />
          </span>
          <div>
            <p className="text-sm font-semibold text-slate-800">Phone</p>
            <p className="text-sm text-slate-600">+91 {MOBILE}</p>
          </div>
        </a>

        <a
          data-testid="contact-whatsapp-link"
          href={`https://wa.me/91${MOBILE}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 rounded-xl border border-green-100 bg-white p-4 shadow-sm transition hover:border-green-300"
        >
          <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-green-50 text-green-600">
            <MessageCircle className="h-5 w-5" />
          </span>
          <div>
            <p className="text-sm font-semibold text-slate-800">WhatsApp</p>
            <p className="text-sm text-slate-600">+91 {MOBILE}</p>
          </div>
        </a>
      </div>
    </div>
  );
}
